import { gql } from "@apollo/client";

export const updateStoreGroupsStatus = gql`
  mutation UpdateStoreGroupsStatus($input: StoreGroupStatusBatchUpdateInput!) {
    updateStoreGroupsStatus(input: $input) {
      success
      code
      message
      updatedCount
    }
  }
`;
